// extracted by mini-css-extract-plugin
export var actions = "resultsList-module--actions--6d4de";
export var activeFilters = "resultsList-module--activeFilters--1b026";
export var activeFiltersContainer = "resultsList-module--activeFiltersContainer--5d76d";
export var backdrop = "resultsList-module--backdrop--a82d1";
export var button = "resultsList-module--button--71bf0";
export var containedImage = "resultsList-module--containedImage--e7fcd";
export var copiedToClipboard = "resultsList-module--copiedToClipboard--7faf7";
export var count = "resultsList-module--count--c75a7";
export var filterTag = "resultsList-module--filterTag--25b04";
export var filters = "resultsList-module--filters--21410";
export var filtersScrollable = "resultsList-module--filtersScrollable--3d111";
export var header = "resultsList-module--header--75a9d";
export var headerContainer = "resultsList-module--headerContainer--18a1f";
export var hidden = "resultsList-module--hidden--874ac";
export var icon = "resultsList-module--icon--33d3a";
export var inSearchPage = "resultsList-module--inSearchPage--3829a";
export var main = "resultsList-module--main--73b71";
export var noResults = "resultsList-module--noResults--1aeba";
export var outerContainer = "resultsList-module--outerContainer--02297";
export var paddedResults = "resultsList-module--paddedResults--ef41d";
export var pt40 = "resultsList-module--pt40--b2363";
export var reset = "resultsList-module--reset--cc274";
export var results = "resultsList-module--results--60369";
export var search = "resultsList-module--search--35a38";
export var separator = "resultsList-module--separator--af2b9";
export var showing = "resultsList-module--showing--fe00f";
export var showingFilter = "resultsList-module--showingFilter--e71cd";
export var sortingBox = "resultsList-module--sortingBox--7211a";
export var sortingButton = "resultsList-module--sortingButton--63466";
export var sortingContainer = "resultsList-module--sortingContainer--1a476";
export var sortingText = "resultsList-module--sortingText--05a62";
export var spinner = "resultsList-module--spinner--ace30";
export var spinnerContainer = "resultsList-module--spinnerContainer--1f0d9";
export var text = "resultsList-module--text--77662";
export var w100 = "resultsList-module--w100--7089d";
export var whiteBg = "resultsList-module--whiteBg--08c07";
export var withBorder = "resultsList-module--withBorder--a7d6c";
export var withSearch = "resultsList-module--withSearch--ce700";